import React, { useContext, useState } from "react";

import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import { SendEmailMessageChat } from "../../OnBoarding/slice";
import { useSelector , useDispatch} from "react-redux";

import {
  arrayUnion,
  doc,
  serverTimestamp,
  Timestamp,
  updateDoc,
  collection as firebaseCollection,
  query,
  where,
  getDocs,
  getDoc,
  setDoc,
  documentId,
  getCountFromServer,
} from "firebase/firestore";
import { db, storage } from "../../../firebase";
import { v4 as uuid } from "uuid";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";

const Input = ({
  chatUid,
  particularChatDonation,
  setChatInputUid,
  collection,
  t,
}) => {
  const {
    messageReducer: {
      chatDonationDetail,
      recevierEntityDetail,
      donationEntityDetail,
    },
    auth: { profile },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [chatId, setChatId] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [entityDonationChatId, setEntityDonationChatId] = React.useState();
  const [text, setText] = useState("");
  async function getEntityDonationChat(
    entityDonationChatUid,
    collectionId,
    donationId
  ) {
    const q = query(
      firebaseCollection(
        db,
        "entityDonationsChat",
        entityDonationChatUid,
        "donationInfo"
      ),
      where(documentId(), "==", donationId + collectionId)
    );
    const resp = await getDocs(q);
    return resp;
  }

  async function createEntityDonations(entityDonationChatUid) {
    const chatUid = uuid();
    try {
      const response = await getEntityDonationChat(
        entityDonationChatUid,
        collection?.collection?.id,
        chatDonationDetail?.donation.donationId
      );
      response.forEach((doc) => {
        setChatId(doc.data().chatUid);
        // getChatCountData(doc.data().chatUid);
      });
      if (response.empty) {
        await setDoc(doc(db, "chats", chatUid), {});
        await setDoc(
          doc(
            db,
            "entityDonationsChat",
            entityDonationChatUid,
            "donationInfo",
            chatDonationDetail?.donation.donationId + collection?.collection?.id
          ),
          {
            donationId: chatDonationDetail?.donation.donationId,
            donation_id: chatDonationDetail?.donation.id,
            expiryDate: chatDonationDetail?.donation.expiryDate,
            availableFromDate: chatDonationDetail?.donation.availableFromDate,
            donationCreatedDate: chatDonationDetail?.donation.createdDate,
            donationProducts: chatDonationDetail?.donationProducts,
            donationEntityDetail: donationEntityDetail?.entity,
            collectionEntityDetail:
              collection?.collection.collectorId === profile?.entity.entityId
                ? profile
                : recevierEntityDetail,
            collectionId: collection?.collection?.id,
            collectionCreatedDate: collection?.collection?.createdDate,
            chatUid: chatUid,
            updatedDate: serverTimestamp(),
          }
        );
        setChatInputUid(chatUid);
      }
    } catch (err) {
      //console.log(err);
    }
  }

  async function fetchEntityChatData() {
    try {
      const q = query(
        firebaseCollection(db, "entityChats", profile?.userId, "entityInfo"),
        where(documentId(), "==", recevierEntityDetail?.userId)
      );
      const resp = await getDocs(q);
      resp.forEach(async (doc) => {
        setEntityDonationChatId(doc.data().entityDonationChatUid);
        await createEntityDonations(doc.data().entityDonationChatUid);
      });
      if (resp.empty) {
        const entityDonationChatUid = uuid();
        await setDoc(
          doc(
            db,
            "entityChats",
            profile?.userId + "/entityInfo/" + recevierEntityDetail?.userId
          ),
          {
            entityId: recevierEntityDetail?.entity.entityId,
            entityName: recevierEntityDetail?.entity.entityName,
            profilePicture: recevierEntityDetail?.entity.profilePicture,
            bannerImage: recevierEntityDetail?.entity.bannerImage,
            entityDonationChatUid: entityDonationChatUid,
            userRegistrationId: recevierEntityDetail?.userId,
          }
        );
        await setDoc(
          doc(
            db,
            "entityChats",
            recevierEntityDetail?.userId + "/entityInfo/" + profile?.userId
          ),
          {
            entityId: profile?.entity.entityId,
            entityName: profile?.entity.entityName,
            profilePicture: profile?.entity.profilePicture,
            bannerImage: profile?.entity.bannerImage,
            entityDonationChatUid: entityDonationChatUid,
            userRegistrationId: profile?.userId,
          }
        );
        setEntityDonationChatId(entityDonationChatUid);
        await createEntityDonations(entityDonationChatUid);
      }
    } catch (err) {
      //console.log(err);
    }
  }

  const handleSendMessage = React.useCallback(
    async (e) => {
      e.preventDefault();
      // e.stopPropogatation()
      if (chatId !== undefined && text.length > 0) {
        setLoading(true);
        const data = {
          donationId: chatDonationDetail?.donation.donationId,
          donation_id: chatDonationDetail?.donation.id,
          donationCreatedDate: chatDonationDetail?.donation.createdDate,
          collectionId:
            collection !== undefined
              ? collection?.collection?.id
              : particularChatDonation?.collectionId,
          collectionCreatedDate:
            collection !== undefined
              ? collection?.collection?.createdDate
              : particularChatDonation?.collectionCreatedDate,
          updatedDate: serverTimestamp(),
        };
        try {
          await updateDoc(
            doc(
              db,
              "entityChats",
              recevierEntityDetail?.userId + "/entityInfo/" + profile?.userId
            ),
            {
              ...data,
              userRegistrationId: profile?.userId,
            }
          );
          await updateDoc(
            doc(
              db,
              "entityChats",
              profile?.userId + "/entityInfo/" + recevierEntityDetail?.userId
            ),
            {
              ...data,
              userRegistrationId: profile?.userId,
            }
          );
          const collectionId =
            collection !== undefined
              ? collection?.collection?.id
              : particularChatDonation?.collectionId;
          await updateDoc(
            doc(
              db,
              "entityDonationsChat",
              entityDonationChatId,
              "donationInfo",
              chatDonationDetail?.donation.donationId + collectionId
            ),
            {
              updatedDate: serverTimestamp(),
            }
          );
        } catch (err) {
         // console.log(err);
          setLoading(false);
        }
        const messageUid = uuid();
        await setDoc(doc(db, "chats", chatId, "messages", messageUid), {
          id: messageUid,
          text,
          senderId: profile?.entity.entityId,
          recevierId: recevierEntityDetail?.userId,
          senderProfilePicture: profile?.entity.profilePicture,
          senderName:
            !profile?.entity.isParentEntity && profile?.entity.isGroupEntity
              ? profile?.entity.entityName
              : profile?.entity.entityName,
          date: Timestamp.now(),
          isRead: false,
          chatUid: chatId,
          ...data,
        });
        setText("");
        setLoading(false);

        const payload = {
          entityId: recevierEntityDetail?.userId
        };
        //// enviar e-mail quando é enviado uma mensagem 
        dispatch(SendEmailMessageChat({ payload }));
        
      }

    },
    [chatId, text]
  );

  React.useEffect(() => {
    if (chatUid === undefined) {
      fetchEntityChatData();
    } else {
      // getChatCountData(chatUid);
      setChatId(chatUid);
    }
  }, [chatUid, text]);

  return (
   
    collection?.collection.status != "CANCELLED" &&
  
    collection?.collection.status != "COLLECTED" &&
    collection?.collection.status != "EXPIRED" &&
    
    <Paper
      component="form"
      className="SendloadingButton"
      sx={{
        p: 2,
        display: "flex",
        alignItems: "center",
        width: 1,
        position: "absolute",
        bottom: 0,
        borderTop: "1px solid rgba(145, 158, 171, 0.24)",
        borderRadius: 0,
      }}
      onSubmit={handleSendMessage}
    >
      <InputBase
      
        sx={{ ml: 1, flex: 1 }}
        placeholder={t("writeYourMessage")}
        inputProps={{ "aria-label": "write your message" }}
        onChange={(e) => {
          e.preventDefault();
          setText(e.target.value);
        }}
        value={text}
      />
      <LoadingButton
        type="submit"
       
        sx={{ p: "10px", borderRadius: "4px" }}
        loading={loading}
        aria-label="send"
        variant="contained"
        startIcon={<SendOutlinedIcon />}
        // onClick={handleSendMessage}
      >
        {t("sendMessage")}
      </LoadingButton>
    </Paper>
  );
};

export default Input;
